;(function () {

  function updateProgress(swiper, sectionEl) {

    const progressFill = sectionEl.querySelector('.product-carousel-progress-fill')

    if (!progressFill) return

    // Real slides count
    let totalSlides = swiper.slides.length

    if (swiper.params.loop) {
      totalSlides = totalSlides - (swiper.loopedSlides * 2)
    }

    // ACTIVE slidesPerView
    let visibleSlides = swiper.params.slidesPerView

    // If breakpoints are active
    if (swiper.currentBreakpoint) {

      const breakpointParams =
        swiper.originalParams.breakpoints?.[swiper.currentBreakpoint]

      if (breakpointParams?.slidesPerView) {
        visibleSlides = breakpointParams.slidesPerView
      }
    }

    visibleSlides = Number(visibleSlides) || 1

    // Maximum movable index
    const maxIndex = totalSlides - visibleSlides

    // Current index
    let currentIndex = swiper.realIndex || 0

    // Progress %
    let progress = 0

    if (maxIndex > 0) {
      progress = (currentIndex / maxIndex) * 100
    }

    // Clamp
    progress = Math.max(0, Math.min(progress, 100))

    progressFill.style.width = `${progress}%`
  }

  let prodcarousel = () => {

    $('.product-carousel-section').each(function () {

      let slideEl = $(this).find('.product-carousel__wrapper')
      let carousel = $(this).find('.swiper-carousel')
      let slide = $(this).find('.swiper-slide')
      let buttonNext = $(this).find('.swiper-button-next')

      if ($(this).hasClass('slider_started')) return
      $(this).addClass('slider_started')

      let id = $(this).attr('id')

      const swiperContainer = document.querySelector(`#${id} .swiper-carousel`)
      const sectionEl = document.getElementById(id)

      let prodSwiperParams = {

        centeredSlides: false,
        slidesPerView: 1,
        spaceBetween: 12,
        watchSlidesProgress: true,
        updateOnWindowResize: true,
        loop: swiperContainer?.dataset.loop === 'true',
        preloadImages: true,
        allowTouchMove: true,

        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 12,
          },

          450: {
            slidesPerView: 1,
            spaceBetween: 12,
          },

          768: {
            slidesPerView: 2,
            spaceBetween: 16,
          },

          990: {
            slidesPerView: 3,
            spaceBetween: 18,
          },

          1200: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
        },

        navigation: {
          nextEl: `#${id} .swiper-button-next__prod`,
          prevEl: `#${id} .swiper-button-prev__prod`,
        },

        on: {

          init: function () {
            updateProgress(this, sectionEl)
          },

          slideChange: function () {

            // Existing animation logic
            if (this.activeIndex === 0) {

              Array.from(slide).forEach((el) =>
                el.classList.remove('slide_change-postion')
              )

              Array.from(carousel).forEach((el) => {
                el.classList.add('carousel_change-postion_next')
                el.classList.remove('carousel_change-postion_prev')
                el.classList.remove('carousel_change-postion_next-2')
              })

            } else {

              if (this.activeIndex > this.previousIndex) {

                Array.from(carousel).forEach((el) => {
                  el.classList.remove('carousel_change-postion_next')
                  el.classList.remove('carousel_change-postion_next-2')
                  el.classList.add('carousel_change-postion_prev')
                })

                Array.from(slide).forEach((el) => {
                  buttonNext.hasClass('swiper-button-disabled')
                    ? el.classList.remove('slide_change-postion')
                    : el.classList.add('slide_change-postion')
                })

              } else {

                Array.from(carousel).forEach((el) => {
                  el.classList.add('carousel_change-postion_next-2')
                  el.classList.remove('carousel_change-postion_prev')
                })

                Array.from(slide).forEach((el) =>
                  el.classList.remove('slide_change-postion')
                )
              }
            }

            // Update progress indicator
            updateProgress(this, sectionEl)

            this.update()
          },
        }
      }

      new Swiper(`#${id} .swiper-carousel`, prodSwiperParams)
    })
  }

  // Event listeners
  document.addEventListener('DOMContentLoaded', prodcarousel)
  document.addEventListener('shopify:section:load', prodcarousel)
  window.addEventListener('resize', prodcarousel)
  document.addEventListener('visibilitychange', prodcarousel)

  prodcarousel()

})()